function ErrorFallbackComponent() {
  return (
    <div className="w-auto text-center text-danger">
      <p className="fw-bold">Something went wrong.</p>
      <p className="mt-1 fs-4">Please try again.</p>
    </div>
  );
}

export default ErrorFallbackComponent;
